




















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { ResponsiveImageViewModel, ResponsiveImageUrl } from '@/models/Image';

@Component
export default class ResponsiveImage extends Vue {
    srcset: string = '';
    @Prop()
    protected image!: ResponsiveImageViewModel;

    constructor() {
        super();
        this.setSrcset();
    }

    beforeUpdate() {
        this.setSrcset();
    }

    getSrcset(): string {
        return this.srcset;
    }

    setSrcset() {
        let srcset = '';
        if (this.image != null && this.image != undefined && this.image.i.length > 0) {
            const ii = this.image.i;
            ii.forEach(url => {
                if (url.u != null && url.u != undefined) {
                    if (url.w != null && url.w != undefined) {
                        srcset += url.u + ' ' + url.w + 'w, ';
                    }
                }
            });

            if (srcset.length > 2) {
                srcset = srcset.slice(0, -2);
            }
        }
        this.srcset = srcset;
    }
}
